<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>{{ argumentType === 0 ? '游戏服务协议' : '用户隐私保护协议'}}</span>
      <img
        :src="fanhuiIcon"
        alt
        :class="$style.fanhui"
        @click="toSure"
      />
    </header>
    <iframe v-if="isSpecial && argumentType === 0" :src="specialLink[0]" frameborder="0"></iframe>
    <iframe  v-if="isSpecial && argumentType === 1" :src="specialLink[1]" frameborder="0"></iframe>
    <!-- <main v-if="!isSpecial && argumentType === 0">
      1. 帐号服务条款的接受
      <br />1.1 帐号由本公司及其关联公司所有并合法运营，本公司及其关联公司并在本用户服务协议的条款和要求下提供服务。
      <br />1.2 当用户访问、浏览及使用帐号提供的各项服务、业务时，用户便表明其接受了本服务协议的条款，并同意受本服务协议的约束，用户并保证其提交的信息真实、准确、及时和完整；若用户不同意本协议条款的，请停止注册程序。
      <br />1.3 本服务协议所称的用户是指完全同意本服务协议所有条款（以下简称“服务条款”）并访问或浏览帐号相关页面的服务接受者。
      <br />
      <br />2. 服务条款的变更和修改
      <br />本公司保留依其自主判断在将来的任何时间变更、修改、增加或删除本服务协议条款的权利。所有修改的协议均构成本服务协议的一部分。本公司有权随时对服务条款进行修改，一旦发生服务条款的变动，本公司将公示修改的内容；当用户使用帐号的任何服务时，应接受帐号随时提供的与该服务相关的规则或说明，并且此规则或说明均构成本服务条款的一部分。用户如果不同意服务条款的修改，可以主动取消已经获得的服务；如果用户继续享用服务，则视为用户已经接受服务条款的修改。
      <br />3. 服务说明
      <br />3.1 本公司运用自己的操作系统通过国际互联网向用户提供丰富的网上资源，包括网盘、书签、邮箱、皮肤、微博、空间、游戏、论坛、SNS社区和实时定位、好友识别等其它个性化服务（以下简称本服务）。除非另有明确规定，基于增强或强化目前服务目的所新增的任何新功能、服务、新产品，均无条件地适用本服务条款。
      <br />3.2 除非本协议中另有规定，否则本公司对服务不承担任何责任，即用户对服务的使用承担风险。本公司不保证服务一定会满足用户的使用要求，也不保证服务不会中断，对服务的及时性、安全性、准确性也不作担保。
      <br />3.3 为使用本服务，用户必须自行配备接入国际互联网所必需的设备，包括计算机、手机、掌上电脑及其他存取装置或接受服务所需其它设备，并自行支付与此服务有关的费用。
      <br />3.4 本公司保留在日后对全部或部分服务项目收取费用的权利。
      <br />3.5 用户接受本服务时，须提供完整、真实、准确、最新的个人资料并按其变更情况不断更新帐号资料。
      <br />3.6 若用户提供任何错误、不实、过时或不完整的资料，或者本公司有合理理由怀疑前述资料为错误、不实、过时或不完整，本公司有权暂停或终止用户的帐号，并拒绝其现在或将来使用本服务的全部或一部分。
      <br />3.7 本公司有权规定并修改使用本服务的一般措施，包括但不限于决定保留电子邮件信息或其他上载内容的时间、限制本服务一个帐号可接收信息的数量等措施。如帐号未能储存或删除本服务的内容或其他信息，本公司不负担任何责任。对于用户3个月未使用的帐号，本公司有权（但无义务）予以删除。
      <br />3.8 由于用户经由本服务张贴、上传或传送内容、与本服务连线、违反本服务条款或侵害其他人的任何权利导致任何第三方提出权利主张或使本公司遭受任何形式的罚款或处罚，用户同意以适当方式充分消除对本公司的不利影响，赔偿本公司及其分公司、关联公司、代理人或其他合作伙伴及员工的损失，并使其免受损害。
      <br />
      <br />4. 用户应遵守以下法律及法规
      <br />用户同意遵守中华人民共和国相关法律、法规的规定，在使用帐号时，不得侵犯任何第三方的合法权益。在任何情况下，如果本公司有合理理由认为用户的行为可能违反上述法律、法规或侵犯第三方的合法权益，本公司可以在任何时候，不经事先通知终止向该用户提供服务。用户应了解国际互联网的无国界性，应特别注意遵守当地所有有关的法律和法规。
      <br />
      <br />5. 用户隐私权
      <br />用户在遵守上述协议要求的前提下，本公司将充分保护用户享有个人隐私。除非因以下原因，未经用户授权，本网站不公开、编辑或透露其个人帐号资料：
      <br />根据有关法律法规的要求；
      <br />按照相关政府主管部门的要求；
      <br />维护社会个体和公众的安全；
      <br />为维护社会公共利益的需要；
      <br />维护本网站的合法权益；
      <br />事先获得用户的明确授权；
      <br />符合其他相关的要求。
      <br />
      <br />6. 用户帐号、密码和安全
      <br />6.1 用户一旦注册成功，便成为本公司的注册用户，将得到一个密码和帐号。用户有义务保证密码和帐号的安全。用户对利用该密码和帐号所进行的一切活动负全部责任；因此所衍生的任何损失或损害，本公司无法也不会承担任何责任。
      <br />6.2 用户的密码和帐号遭到未授权的使用或发生其他任何安全问题，用户可以立即通知本公司。用户在每次连线结束，应结束帐号使用，否则用户可能得不到帐号的安全保护。
      <br />6.3 本公司禁止用户交易帐号，本公司有权收回用户交易的帐号。如果因用户交易帐号引起的任何纠纷，本公司不承担任何责任。
      <br />
      <br />7. 对用户信息的存储和限制
      <br />本公司不对用户在帐号任何服务下发布信息的删除或储存失败负责。本公司有权判断用户的行为是否符合帐号服务条款的规定，如果本公司认为用户违反了服务条款的规定，本公司有权删除用户发布或发送的信息，直至中断或终止向其提供服务。
      <br />8. 禁止用户从事以下行为：
      <br />8.1 上载、张贴、发送或传送任何非法、淫秽、色情、低俗的，胁迫、骚扰、中伤他人的，诽谤、侵害他人隐私或诋毁他人名誉或商誉的，其他违反国家法律法规、社会主义道德规范及不适当的信息或电子邮件，包括但不限于资讯、资料、文字、软件、音乐、照片、图形、信息、视频或其他资料（以下简称内容）。
      <br />8.2 以任何方式危害未成年人。
      <br />8.3 冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关。
      <br />8.4 伪造标题或以其他方式操控识别资料，使人误认为该内容为本公司所传送。
      <br />8.5 上载、张贴、发送电子邮件或以其他方式传送无权传送的内容。
      <br />8.6 上载、张贴、发送电子邮件或以其他方式传送侵犯任何人的专利、商标、著作权、商业秘密或其他民事权利之内容。
      <br />8.7 上载、张贴、发送电子邮件或以其他方式传送广告函件、促销资料、垃圾邮件等。
      <br />8.8 干扰或破坏本服务或与本服务相连的服务器和网络，或不遵守本服务协议之规定。
      <br />8.9 违反任何相关的中国法律、法规、规章、条例等其他具有法律约束力的规范。
      <br />8.10 跟踪或以其他方式骚扰他人。
      <br />8.11 窃取他人密码、帐号和其它数字化信息或财产。
      <br />8.12 其他被本公司视为不适当的行为。
      <br />8.13 本公司有权对用户载、张贴、发送的内容进行审核，有任何违反法律法规或本协议之有关规定的内容，本公司有权立即将其删除或屏蔽，且不需要对用户另行通知。
      <br />8.14 帐号封号规则
      <br />1.无视国家规定，在姓名、游戏角色名等地方中使用违规词语或不文明词语、非法字符 处罚规则：视情节轻重给予时限性冻结帐号的处罚；情节严重者，给予永久冻结的处罚。
      <br />2.涉及到侵入、拦截、破坏、复制、修改游戏程序，以及宣扬、叫卖和使用各种辅助性程序或恶性非法程序，即使用外挂程序、或在游戏中宣传外挂程序的行为。
      <br />处罚规则：视情节轻重给予时限性冻结帐号的处罚；情节严重者，给予永久冻结的处罚。
      <br />3.以任何弄虚作假的形式来蒙蔽或者欺骗其他用户，如发布模仿官方并带有病毒的网站、非官方中奖信息、非法广告、游戏代码、木马、外挂、病毒、色情信息、垃圾广告等信息
      <br />处罚规则：视情节轻重给予时限性冻结帐号的处罚；情节严重者，给予永久冻结的处罚。
      <br />4.通过帐号发布非法网站，宣传或使用私服、游戏代码、木马、外挂、病毒、色情信息、垃圾广告、非法广告等信息
      <br />处罚规则：视情节轻重给予时限性冻结帐号的处罚；情节严重者，给予永久冻结的处罚。
      <br />5.通过帐号发布触犯政府法令的文字如：煽动、反动、猥亵、暴力、种族歧视、宗教歧视等字眼，包含这类相关字的反向书写。
      <br />处罚规则：视情节轻重给予时限性冻结帐号的处罚；情节严重者，给予永久冻结的处罚，并上报相关部门追究其法律责任。
      <br />6.宣传或贩卖BUG、攻击服务器运行、牟取个人利益、影响游戏公平性，以及影响其他玩家正常进行游戏等行为
      <br />处罚规则：查证核实后，将暂停帐号，并清除所有非法物品；视情节轻重给予时限性冻结帐号的处罚；情节严重者，给予永久冻结的处罚。
      <br />7.盗取或参与盗取他人帐号，给被盗者造成严重损失的行为
      <br />处罚规则：查证核实后，视情节轻重给予时限性冻结帐号的处罚；情节严重者，给予永久冻结的处罚，并上报相关部门追究其法律责任。
      <br />8.侮辱、毁谤、猥亵、威胁、辱骂其他用户，扭曲事实、恶意散布不实谣言，恶意影响游戏环境等行为
      <br />处罚规则：视情节轻重给予时限性冻结帐号的处罚；情节严重者，给予永久冻结的处罚。
      <br />
      <br />9. 内容及其披露
      <br />9.1 用户对经由本服务上载、张贴或传送的内容负全部责任；对于经由本服务而传送的内容，本公司不保证前述内容的正确性、完整性或及时性。在任何情况下，本公司均不对任何用户提供的内容负责，包括但不限于任何内容发生任何错误或纰漏以及衍生的任何损失或损害，用户负责处理与其提供的内容相关的任何及全部纠纷。本公司有权（但无义务）拒绝或删除经由本服务提供的任何内容。用户使用上述内容，应自行承担风险。
      <br />9.2 本公司有权利在下述情况下，对内容进行保存或披露：
      <br />法律程序所规定
      <br />本服务条款规定
      <br />被侵害的第三人提出权利主张
      <br />为保护帐号、其使用者及社会公众的权利、财产或人身安全
      <br />其他本公司认为有必要的情况。
      <br />
      <br />10. 电子公告栏的张贴内容
      <br />10.1 “电子公告栏”包括空间、论坛、SNS社区和其它一般公众可以使用的区域；
      <br />10.2 用户一旦在本服务电子公告栏上传或张贴内容，即视为用户授予本公司该内容著作权之免费及非独家、永久的许可使用权，本公司有权为展示、传播及推广前述内容之目的，对上述内容进行复制、修改、出版。由此展示、传播及推广行为所产生的损失或利润，均由本公司承担或享受。本公司有权自主决定是否给予此类用户鼓励或奖励。
      <br />10.3 因用户进行上述张贴，而导致任何第三方提出索赔要求或衍生的任何损害或损失，用户须承担全部责任。
      <br />10.4 非经本公司事先许可，用户不得对他人上传或张贴在电子公告栏或本服务其他内容进行复制、出售或用作其他商业用途。
      <br />
      <br />11. 帐号服务使用规则
      <br />11.1 用户必须保证，拥有上传之照片、文字等作品之著作权或已获得合法授权，在本网站之上传行为未侵犯任何第三方之合法权益。否则，将由用户承担由此带来的一切法律责任；用户不得将任何内部资料、机密资料、涉及他人隐私资料或侵犯任何人的专利、商标、著作权、商业秘密或其他专属权利之内容加以上载、张贴、或以其他方式传送。
      <br />11.2 用户不得利用本服务进行故意制作、传播计算机病毒等破坏性程序，不得针对本服务、与本服务连接的服务器或网络制造干扰、混乱，或违反连接本服务的网络的任何要求、程序、政策或规则，否则本公司将保留追究其法律责任的权利并有权将其提交给相关部门处理。
      <br />11.3 本公司有权对用户上传的图片、添加的文字等内容进行审核，有任何违反法律法规或本协议之有关规定的图片、文字，本公司有权立即将其删除或屏蔽，且不需要对用户另行通知。
      <br />11.4 用户不得将广告函件、促销资料、垃圾邮件等，加以上载、张贴、发送电子邮件或以其他方式传送。
      <br />11.5 本公司郑重提请用户注意，任何经由本服务以上载、张贴、发送的资料、文字、照片、图形、视讯、信息、用户的登记资料或其他资料（以下简称“内容”），无论系公开还是私下传送，均由内容提供者承担责任。本公司无法控制经由本服务传送之内容，也无法对用户的使用行为进行全面控制，因此不保证内容的合法性、正确性、完整性、真实性或品质；用户已预知使用本服务时，可能会接触到令人不快、不适当或令人厌恶之内容，并同意将自行加以判断并承担所有风险，而不依赖于本公司。但在任何情况下，本公司有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。但本公司有权(但无义务)依其自行之考量，拒绝和删除可经由本服务提供之违反本条款的或其他引起本公司或用户反感的任何内容。
      <br />11.6 用户完全理解并同意，若第三方在用户不知情或未经用户同意的前提下，将其文字、图片作品上传于帐号空间及由此所产生的任何可能侵害其权益的行为，本公司均不对任何人承担任何责任。
      <br />11.7 本公司有权根据政府机关或权利人的要求删除用户上载、张贴、发送的内容，无论本公司事先是否通知。
      <br />11.8 本公司有权根据服务的需要，收回用户所用的空间域名或减少用户所用空间的大小，无论本公司事先是否通知。
      <br />
      <br />12. 论坛规则
      <br />12.1 关于用户名和昵称
      <br />不得使用党和国家领导人或其他知名人士的真实姓名、字号、艺名、笔名作为用户名和昵称；
      <br />不得使用国家机构或其他机构的名称作为用户名和昵称；
      <br />不得使用和其他网友之名相近、相仿的用户名和昵称；
      <br />不得使用不文明、不健康，或带攻击性、侮辱性的用户名和昵称；
      <br />请勿使用易产生歧义、引起他人误解的用户名和昵称；
      <br />不得使用各种奇形怪状的符号作为用户名和昵称；
      <br />对于违反规定或产生不良后果的用户名和昵称，本站有权删除而不必事先通知。
      <br />12.2 关于签名
      <br />不得出现宣扬反动、封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪等不符合国家法律规定的以及任何包含种族、性别、宗教歧视性和猥亵性的信息内容；
      <br />不得出现有侮辱性言语、挑衅、辱骂其他人以及不健康内容；
      <br />不得出现广告性质的内容以及本公司以外其他网站的链接；
      <br />本公司有权在不需要通知和解释的情况下除去违反以上规定的签名内容,并对情节严重者予以封号处理。
      <br />12.3 关于发贴内容
      <br />遵守相关法规，严禁发表违反法律法规及社会主义道德规定的内容；
      <br />使用文明用语，不得张贴对任何人进行人身攻击、谩骂、诋毁的言论；
      <br />不得张贴未经公开报道、未经证实的消息；
      <br />不得张贴与所在论坛主题无关的消息、言论和图片；
      <br />未经本公司同意，不得张贴带有商业性质的内容或任何形式的广告，不得张贴本公司及其关联公司以外其他网站的链接；
      <br />不得恶意灌水，内容相同的帖子不得一文多发；
      <br />不得在帖子中（标题和内容）加入各种奇形怪状的符号；
      <br />转贴文章应注明原始出处和时间；
      <br />对于违反以上规定的内容，在不需要通知和解释的情况下，本公司以及版主有权予以删除，并对情节严重者予以封帐号处理。
      <br />12.4 关于贴图
      <br />不得张贴宣扬反动、封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪等不符合国家法律规定的以及任何包含种族、性别、宗教歧视性和猥亵性的图片；
      <br />不得出现带有侮辱性、挑衅、辱骂其他人以及不健康内容的图片；
      <br />请勿使用易产生歧义、引起他人误解的图片；
      <br />摘录、转贴的图片请注明出处及作者，禁止张贴侵犯他人著作权、版权等知识产权的图片；
      <br />不得张贴与论坛主题无关的图片；
      <br />本公司有权在不需要通知和解释的情况下删除违反以上规定的图片，并对情节严重者予以封帐号处理。
      <br />
      <br />13. 帐号游戏规则
      <br />13.1 用户应当遵守游戏公约、玩家守则及不时发布的游戏规则、公告等；
      <br />13.2 用户不得通过不正当的手段或其他不公平的手段使用帐号的游戏产品和服务或参与帐号的游戏活动。用户不得干扰本公司正常地提供产品和服务，包括但不限于：攻击、侵入本公司的网站服务器或使网站服务器过载；制作、发布、传播、使用任何形式的妨碍游戏公平性的辅助工具或程序(外挂)；利用程序的漏洞和错误(Bug)破坏游戏的正常进行或传播该漏洞或错误(Bug)；不合理地干扰或阻碍他人使用本公司所提供的产品和服务。
      <br />13.3 为维护游戏的公平性，如果本公司发现用户数据异常，无论用户对该异常数据产生是否负有过错，本公司均有权根据本规则、游戏公约、玩家守则及后期不时发布的游戏公告等，采取相应措施：包括但不限于对该帐号的冻结、终止、删除；用户在此承诺本公司有权采取上述行动，并承诺不得就上述行为要求本公司做任何补偿或退费。
      <br />13.4 本公司在此特别提示用户：
      <br />本公司提供的游戏将按照现状提供，用户明确知道游戏中存在已知和未知的漏洞和错误（Bug）。尽管本公司将尽最大努力解决已知的漏洞和错误（Bug），但用户知道或应该知道游戏中仍可能包含未知的漏洞和错误（Bug）等。用户同意不向本公司及其关联公司因任何漏洞和错误（Bug）主张任何赔偿。本公司不提倡虚拟物品之间的交易，并不对该交易中产生的任何问题进行支持和保障。
      <br />
      <br />14. 手机特色功能说明
      <br />14.1 用户明确知道，本公司提供的实时定位服务将向用户及用户的不特定帐号好友提供用户的实时空间位置信息。
      <br />14.2 用户可选择向帐号导入手机通讯簿上所对应的好友关系链，但本公司确保将不导入好友关系链之外的任何信息（包括好友姓名及其他任何相关信息）
      <br />14.3 本公司将对好友关系链通过不可逆转的方式加密存储，包括帐号和您的任何好友都将无法获知您的真实好友关系链和真实手机号码。
      <br />
      <br />15. 本公司的知识产权及其他权利
      <br />15.1 本公司对本服务及本服务所使用的软件和受知识产权相关法律或其他法律保护的资料享有相应的权利。
      <br />15.2 经由本服务传送的内容，受到著作权法、商标法、专利法或其他法律的保护；未经本公司明示授权许可，用户不得进行修改、出租、散布或衍生其他作品，用户本人创作并在公开使用区域张贴的内容除外。
      <br />15.3 用户对本服务所使用的软件有非专属性使用权，但自己不得或许可任何第三方复制、修改、出售或衍生产品。
      <br />15.4 帐号及其他帐号图样、产品及服务名称，均为本公司及其关联公司所享有的商标，未经本公司所事先书面授权，任何人不得使用、 复制或用作其他用途。
      <br />
      <br />16. 免责声明
      <br />16.1 本公司对于本服务包含的或用户经由或从任何与本服务有关的途径所获得的任何内容、信息或广告，不保证其正确性或可靠性；并且对于用户经本服务上的广告、展示而购买、取得的任何产品、信息或资料，本公司不负保证责任。用户自行承担担使用本服务的风险。
      <br />16.2 本公司有权但无义务，改善或更正本服务任何部分之任何疏漏、错误。
      <br />16.3 本公司不保证以下事项（包括但不限于）：
      <br />本服务适合用户的使用要求；
      <br />本服务不受干扰，及时、安全、可靠或不出现错误；
      <br />用户经由本服务取得的任何产品、服务或其他材料符合用户的期望；
      <br />16.4 用户使用经由本服务下载的或取得的任何资料，其风险自行负担；因该使用而导致用户手机或其他设备系统损坏或资料流失，用户应负完全责任；
      <br />16.5 对基于以下原因而造成的利润、商业信誉、资料的损失或其他有形或无形损失，本公司不承担任何直接、间接、附带、衍生或惩罚性的赔偿：
      <br />本服务使用或无法使用；
      <br />经由本服务购买或取得的任何产品、资料或服务；
      <br />用户资料遭到未授权的使用或修改；
      <br />用户资料丢失或被删除；
      <br />其他与本服务相关的事宜。
      <br />16.6 用户在浏览网际网路时自行判断使用帐号的检索目录。该检索目录可能会引导用户进入到被认为具有攻击性或不适当的网站，本公司没有义务查看检索目录所列网站的内容，因此，对其正确性、合法性、正当性不负任何责任。
      <br />
      <br />17. 服务的修改和终止
      <br />本公司有权在未事前通知的情况下在任何时候，暂时或永久地修改或终止本服务或其中任何一部分。本公司对本服务的修改或终止对用户和任何第三人不承担任何责任。本公司有权基于任何理由，终止用户的帐号、密码或拒绝其使用本服务，或删除、转移用户存储、发布在本服务的内容，本公司采取上述行为均不需通知，并且对用户和任何第三人不承担任何责任。
      <br />
      <br />18. 通知
      <br />本公司向用户发出的通知，可以采用电子邮件、页面公告、常规信件、电话或本公司认为适合的形式。服务条款的修改或其他事项变更时，本公司将会以上述形式进行通知。
      <br />
      <br />19. 全部协议
      <br />本服务协议和本公司的其他服务条款构成完整的协议。
      <br />20. 法律的适用和管辖
      <br />本服务条款的生效、履行、解释及争议的解决均适用中华人民共和国法律，发生的争议提交杭州仲裁委员会裁决。如果本服务协议中某项条款因与中华人民共和国现行法律相抵触而导致无效，将不影响其他部分的效力。
      <br />21. 生效条件
      <br />本协议自用户访问、浏览及使用帐号之时开始生效。
      <br />
    </main> -->
    <iframe  v-if="!isSpecial && argumentType === 0" :src="fuwu" frameborder="0"></iframe>
    <iframe  v-if="!isSpecial && argumentType === 1" :src="yinSi" frameborder="0"></iframe>
  </div>
</template>

<script>
import isFullScreen from '@/libs/business/fullScreen'
import { mapState } from 'vuex'

export default {
  name: "",
  props: [
    "isSuspend"
  ],
  data() {
    return {
      yinSi: '//sdk-static.zhangyuqu.com/Lianyun/yinsi/yinsi-wx.html',
      fuwu: '//sdk-static.zhangyuqu.com/Lianyun/yinsi/fuwu-wx.html',
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/fanhui.png`,
      fullScreen: '',
      isSpecial: false,
      specialLink: ['', ''],
      private_status: '',
      user_private_protect_policy: '',
      user_service_policy: ''
    };
  },
  created() {
    this.fullScreen = isFullScreen() || this.isSuspend;
  },
  mounted() {
    this.private_status = this.$getStorage('private_status');
    this.user_private_protect_policy = this.$getStorage('user_private_protect_policy');
    this.user_service_policy = this.$getStorage('user_service_policy');
    this.judgeSpecial()
  },
  computed: {
    ...mapState({
      argumentType: state => state.user.argumentType
    })
  },
  methods: {
    toSure() {
      this.$emit("redirectRegist");
      this.$emit('close'); // 悬浮窗处使用
    },
    // 处理荣耀游戏协议
    judgeSpecial() {
      const specialList = {
        '200010893': ['https://sdk-static.zhangyuqu.com/Lianyun/yinsi/fuwu-ry.html', 'https://sdk-static.zhangyuqu.com/Lianyun/yinsi/yinsi-ry.html'],
        '200010892': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200010891': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200010890': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200010889': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200010888': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200010669': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        // '100000001': ['https://sdk-static.zhangyuqu.com/Lianyun/yinsi/fuwu-ry.html', 'https://sdk-static.zhangyuqu.com/Lianyun/yinsi/yinsi-ry.html'],
        '200011085': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011086': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011087': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011088': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011089': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011084': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011090': ['https://sdk-static.zhangyuqu.com/Lianyun/yinsi/fuwu-ry.html', 'https://sdk-static.zhangyuqu.com/Lianyun/yinsi/yinsi-ry.html'],
        '200011283': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011288': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011284': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011285': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011286': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011274': ['https://user.cn.sy.iskywan.com/app/main/api/ApiGetAgreement.php?gid=161&pkid=1&pcid=1&cid=13&aid=101&osid=1&type=yl', 'https://user.cn.sy.iskywan.com/app/main/api/ApiGetReivarcyUrl.php?gid=161&osid=1&type=yl'],
        '200011287': ['https://sdk-static.zhangyuqu.com/Lianyun/yinsi/fuwu-ry.html', 'https://sdk-static.zhangyuqu.com/Lianyun/yinsi/yinsi-ry.html'],
        '200011516': ['https://sdk-static.zhangyuqu.com/Lianyun/yinsi/fuwu-wx.html', 'https://sdk-static.zhangyuqu.com/Lianyun/yinsi/yinsi-tg2.html'],
        '200011611': ['https://sdk-static.zhangyuqu.com/Lianyun/yinsi/fuwu-wx.html', 'https://sdk-static.zhangyuqu.com/Lianyun/yinsi/yinsi-douyin.html'],
        '200011318': ['https://sdk-static.zhangyuqu.com/Lianyun/yinsi/fuwu-wx.html', 'https://sdk-static.zhangyuqu.com/Lianyun/yinsi/yinsi-rxwd.html'],
        '200012109': ['https://sdk-static.zhangyuqu.com/Lianyun/yinsi/fuwu-wx.html', 'https://sdk-static.zhangyuqu.com/Lianyun/yinsi/yinsi-tg2.html'],
      }
      const appkey = this.$getStorage('appkey');
      if (specialList[appkey]) {
        this.isSpecial = true;
        this.specialLink = specialList[appkey];
      } else if (this.private_status == 1) {
        this.isSpecial = true;
        this.specialLink = [
          this.user_service_policy,
          this.user_private_protect_policy
        ]
      }
    }
  },
};
</script>

<style lang="scss" module>
@import "../../../assets/css/common.scss";

.wrap {
  @include common-window();
  z-index: 100;
  > header {
    position: relative;
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding: 0.38rem 0.24rem;
    overflow-y: auto;
  }
  > iframe {
    width: 100%;
    height: calc(100% - 0.93rem);
    background: #ffffff;
    border-radius: 1rem 0rem 0.2rem 0.2rem;
    box-sizing: border-box;
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding: 19px 12px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    > iframe {
      width: 100%;
      height: calc(100% - 46px);
      background: #ffffff;
      border-radius: 50px 0 10px 10px;
      box-sizing: border-box;
    }
  }
}
</style>